import { Injectable, DependencyLifeTime } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../contexts/DependencyContext";
import { DataSourceService } from "./http/datasource/DataSourceService";
import { IDataSource } from "./http/datasource/models/IDataSource";
import { MeasureService } from "./http/measure/MeasureService";
import { GetDataSourceMeasureHistoryByPointsParameters } from "./http/measure/models/GetDataSourceMeasureHistoryByPointsParameters";
import { GetDataSourceMeasureSummaryParameters } from "./http/measure/models/GetDataSourceMeasureSummaryParameters";
import { IMeasureSummary } from "./http/measure/models/IMeasureSummary";
import { INumericTimeSeriesPoints } from "./http/measure/models/INumericTimeSeriesPoints";
import { DateService } from "./types/DateService";

export interface IDataSourceModel
{
    dataSource: IDataSource;
    measureSummary: IMeasureSummary;
}

export interface IDataSourceHistory {
    dataSource: IDataSource;
    measureHistory: INumericTimeSeriesPoints;
}

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class DataSourceModelService
{
    constructor(
        private readonly dataSourceService: DataSourceService,
        private readonly measureService: MeasureService,
        private readonly dateService: DateService
    )
    {
    }

    async getDataSourceData(dataSourceId: number, date: Date): Promise<IDataSourceModel>
    {
        const parameters = new GetDataSourceMeasureSummaryParameters();
        parameters.dataSourceId = dataSourceId;
        parameters.date = date;

        const [dataSource, measureSummary] = await Promise.all([
            this.dataSourceService.getById(dataSourceId),
            this.measureService.getDataSourceMeasureSummary(parameters)
        ]);

        return { dataSource, measureSummary };
    }

    async getDataSourceHistory(dataSourceId: number, date: Date, maxPoints: number): Promise<IDataSourceHistory>
    {
        const parameters = new GetDataSourceMeasureHistoryByPointsParameters();
        parameters.dataSourceId = dataSourceId;
        parameters.fromDate =  this.dateService.addDays(date, -1);
        parameters.toDate = date;
        parameters.maxPoints = maxPoints;
        
        const [dataSource, measureHistory] = await Promise.all([
            this.dataSourceService.getById(dataSourceId),
            this.measureService.getNumericTimeSeriesPoints(parameters)
        ]);

        return { dataSource, measureHistory };
    }
}